import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';


const mapStateToProps = state => ({
  adminMode: state.admin.adminMode,
  konamiMode: state.styles.konamiMode,
  activeStyle: state.styles.activeStyle,
});

class Notifications extends Component {

  isDiff(prevProps, propName) {
    return prevProps[propName] !== this.props[propName];
  }

  componentDidUpdate(prevProps) {

    if (this.isDiff(prevProps, 'adminMode')) {
      NotificationManager.success(`Admin mode ${this.props.adminMode ? 'activated' : 'deactivate'}`, '', 2000);
    } else if (this.isDiff(prevProps, 'konamiMode')) {
      NotificationManager.success(`Konami Code entered`, '', 2000);
    } else if (this.isDiff(prevProps, 'activeStyle')) {
      NotificationManager.success(`${this.props.activeStyle} Style toggled`, '', 2000);
    }
  }

  render() {
    return <NotificationContainer/>;
  }
}
 
export default connect(mapStateToProps)(Notifications);




// WEBPACK FOOTER //
// ./src/components/Notifications.js